// eslint-disable-next-line import/prefer-default-export
export const AGENCY_SEARCH_PARAM_KEYS = {
  AGENCY: 'agency',
};
